import React, { useState } from 'react';
import classnames from 'classnames';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import {useAppState} from '@nutastic/nutastic-react-app';

const Header = () => {
    const { useHalfHeader = false } = useAppState();
    const componentClass = 'header';
    const scrollThreshold = 650;
    const [hasPastScrollThreshold, setHasPastScrollThreshold] = useState(false);
    const classes = classnames(componentClass, 'animated', 'fadeInDown', {
        [`${componentClass}--pastTheFold`]: hasPastScrollThreshold,
        [`${componentClass}--halfHeader`]: useHalfHeader && !hasPastScrollThreshold
    });

    useScrollPosition(({ prevPos, currPos }) => {
        const { y = 0 } = currPos;
        if (y < -scrollThreshold) {
            !hasPastScrollThreshold && setHasPastScrollThreshold(true);
        } else {
            hasPastScrollThreshold && setHasPastScrollThreshold(false);
        }
    }, [hasPastScrollThreshold]);

    return <header className={classes}>
        <a href="/home" className="left-side-link">Home</a>
        <a href="/about" className="left-side-link">Details</a>
        <span>
            <i className="ion-md-heart-empty full" />
            <i className="ion-md-heart left-heart" />
            <i className="ion-md-heart right-heart" />
        </span>
        <a href="/gallery" className="right-side-link">Gallery</a>
        <a href="/reserve" className="right-side-link">RSVP</a>
    </header>;
};

export default Header;
